import { SessionFixedCommentState, TestFixedCommentsState } from "../UseFixedComments";

export const SelectedSessionCommentsCount = (sessionFixedComments: SessionFixedCommentState) => sessionFixedComments.comments.filter(
    x => x.selected
).length;

export const SelectedTestCommentsCount = (testFixedComments: TestFixedCommentsState[]) => testFixedComments.map(x => ({
        id: x.id,
        count: x.comments.filter(x => x.selected).length
    }));
